<template>
  <div class="vacancy-additional-questions relative">
    <div
      v-if="!vacancyCreated"
      class="card-disable-cover _white"
      @click="$emit('click:disable-cover', $event)"
    ></div>

    <div class="edit-group" data-edit-group="8">
      <div
        v-for="(item, index) in additionalQuestions"
        :key="index"
        class="edit-group__card relative"
        :class="{ '_current-draggable': (item.id || item.tempId) === draggableQuestionId }"
        :draggable="(item.id || item.tempId) === draggableQuestionId ? 'true' : 'false'"
        @dragover="onQuestionDragOver(item)"
        @dragend="onItemDragEnd"
      >
        <BasePreloader v-if="loading.questionsDelete[item.id || item.tempId]" />

        <div class="vacancy-additional-questions__move-card-actions">
          <div class="vacancy-additional-questions__move-buttons">
            <button
              class="base-btn"
              @click="setUpperPosition(item, index)"
            >
              <BaseSvg name="ico-chevron-up" width="0.9rem" height="0.6rem" />
            </button>

            <div
              class="base-btn vacancy-additional-questions__move-button-draggable"
              @mousedown="startQuestionDrag(item)"
              @mouseup="onItemDragEnd"
            >
              <span></span>
              <span></span>
              <span></span>
            </div>

            <button
              class="base-btn"
              @click="setLowerPosition(item, index)"
            >
              <BaseSvg name="ico-chevron-down" width="0.9rem" height="0.6rem" />
            </button>
          </div>
        </div>

        <div class="vacancy-additional-questions__edit-buttons">
          <button
            class="base-btn"
            :class="{ _blue: item.edit }"
            @click="toggleEditMode(index)"
          >
            <BaseSvg name="ico-pencil" width="1.5rem" height="1.5rem" />
          </button>
          <button
            class="base-btn"
            @click="deleteQuestionBlock(item, index)"
          >
            <BaseSvg name="ico-trash" width="1.3rem" height="1.6rem" />
          </button>
        </div>

        <template v-if="item.edit">
          <BaseRadioList
            :value="item.questionType"
            :options="questionTypes"
            :text-key="option => $tNewVacancy2(option.title)"
            :is-checked="(value, option) => value.id === option.id"
            class="vacancy-additional-questions__radio-question-type"
            @input="setQuestionType(item, $event)"
          />

          <TranslateFiled
            v-model="item.question"
            :label="getQuestionInputTitle(item.questionType.id)"
            :use-translate-buttons="useFieldsTranslations"
            class="_white _shadow mt-7"
            :original-locale="originalLocale"
            @input="onItemQuestionInput($event, index)"
          />

          <div
            v-if="item.questionType.id === QuestionType.Closed"
            class="mt-5"
          >
            <div class="d-flex">
              <span class="edit-group__sub-title _top-lighter">
                {{ $tNewVacancy2('set_anwser_options') }}
              </span>
            </div>

            <div class="vacancy-additional-questions__answer-variants">
              <div
                v-for="(variant, variantIndex) in item.answerVariants"
                :key="variantIndex"
                class="vacancy-additional-questions__answer-variant"
                :class="{ '_current-draggable': draggableAnswer && variant.tempId === draggableAnswer.tempId }"
                draggable="true"
                @dragstart="draggableAnswer = variant"
                @dragover="onAnswerDragOver({ question: item, answerIdx: variantIndex })"
                @dragend="onItemDragEnd"
              >
                <TranslateFiled
                  v-model="variant.title"
                  class="_shadow _white full-width"
                  :use-header="useFieldsTranslations"
                  :use-translate-buttons="useFieldsTranslations"
                  :original-locale="originalLocale"
                  @input="changeAction"
                >
                  <template v-slot:prepend>
                    <div class="d-flex items-center">
                      <SwitchCheckbox
                        v-model="variant.show"
                        class="_blue mr-3"
                        @input="changeAction"
                      />

                      <div class="vacancy-additional-questions__answer-variant-sort-buttons mr-2">
                        <button
                          class="base-btn"
                          @click="setAnswerUpperPosition({ question: item, answer: variant, answerIdx: variantIndex })"
                        >
                          <BaseSvg name="ico-chevron-up" width="1.2rem" height="0.8rem" />
                        </button>
                        <div class="vacancy-additional-questions__answer-variant-number">
                          {{ variantIndex + 1 }}
                        </div>
                        <button
                          class="base-btn"
                          @click="setAnswerLowerPosition({ question: item, answer: variant, answerIdx: variantIndex })"
                        >
                          <BaseSvg name="ico-chevron-down" width="1.2rem" height="0.8rem" />
                        </button>
                      </div>
                    </div>
                  </template>
                </TranslateFiled>
<!--           TODO temporary comment     -->
<!--                <div class="relative">-->
<!--                  <div-->
<!--                    v-if="variantIndex === 0"-->
<!--                    class="vacancy-additional-questions__answer-variant-points-title"-->
<!--                  >-->
<!--                    <div class="edit-group__sub-title _top-lighter">-->
<!--                      {{ $tNewVacancy2('points_for_answer') }}-->
<!--                    </div>-->

<!--                    <div class="relative pl-2">-->
<!--                      <BaseTooltip-->
<!--                        :text="$tNewVacancy2('points_for_answer_tooltip')"-->
<!--                        tooltip-menu-style="bottom: 140%"-->
<!--                      >-->
<!--                        <template v-slot:activator="{ on }">-->
<!--                          <div-->
<!--                            class="vacancy-additional-questions__answer-variant-points-title-tooltip"-->
<!--                            v-on="on"-->
<!--                          >-->
<!--                            ?-->
<!--                          </div>-->
<!--                        </template>-->
<!--                      </BaseTooltip>-->
<!--                    </div>-->
<!--                  </div>-->

<!--                  <BaseInput-->
<!--                    v-model="variant.points"-->
<!--                    type="number"-->
<!--                    class="_shadow _white"-->
<!--                  />-->
<!--                </div>-->

                <button
                  class="base-btn base-btn--small align-end ml-1"
                  style="margin-bottom: 0.9rem;"
                  :style="`visibility: ${item.answerVariants.length > 1 ? 'visible': 'hidden'}`"
                  @click="deleteAnswerVariant(index, variantIndex)"
                >
                  <BaseSvg name="ico-close" width="1.3rem" height="1.3rem" />
                </button>
              </div>
            </div>

            <div v-if="item.answerVariants.length < 4" class="d-flex mt-7">
              <button
                class="base-btn  base-btn--outline-grey base-btn--small"
                @click="addAnswerVariant(index)"
              >
                <BaseSvg name="ico-plus" width="1.3rem" height="1.4rem" />
                <span>{{ $tNewVacancy2('add_answer') }}</span>
              </button>
            </div>
          </div>
        </template>

        <template v-else>
          <span class="edit-group__sub-title _top-lighter">{{ $tNewVacancy2(item.questionType.title) }}</span>
          <h4 class="edit-group__title">{{ getFormattedText(item.question) }}</h4>

          <div
            v-if="item.questionType.id === QuestionType.Closed"
            class="mt-7"
          >
            <div class="edit-group__sub-title _top-lighter">{{ $tNewVacancy2('answer_options') }}:</div>
            <div class="vacancy-additional-questions__answer-rows">
              <div
                v-for="(variant, variantIndex) in item.answerVariants"
                :key="variantIndex"
                class="vacancy-additional-questions__answer-row"
              >
<!--            TODO temporary hide    -->
<!--                <div-->
<!--                  class="vacancy-additional-questions__answer-row-points"-->
<!--                  :class="{ _blue: Number(variant.points) }"-->
<!--                >-->
<!--                  {{ Number(variant.points) ? `+ ${variant.points}` : 0 }}-->
<!--                </div>-->
                <div>{{ getFormattedText(variant.title) }}</div>
              </div>
            </div>
          </div>
        </template>
      </div>

      <div v-if="!additionalQuestions.length">
        <div class="d-flex justify-center mt-3 mb-14">
          <img src="../../assets/img/vacancy-page/empty-vacancy-circles.png" alt="">
        </div>
        <div class="vacancy-additional-questions__empty-description mb-1">
          {{ $tNewVacancy2('here_you_can_indicate_questions') }}
        </div>
      </div>

      <div class="d-flex" :class="additionalQuestions.length ? 'justify-flex-end' : 'justify-center'">
        <button
          class="base-btn  base-btn--outline-grey base-btn--small"
          @click="addQuestionBlock"
        >
          <BaseSvg name="ico-plus" width="1.3rem" height="1.4rem" />
          <span>{{ $tNewVacancy2('add_question') }}</span>
        </button>
      </div>

      <div v-if="isOur">
        <BaseCheckbox
          :label="$tNewVacancy2('translate_additional_questions')"
          @input="translateAdditionalQuestionsInput"
        />
      </div>
    </div>
  </div>
</template>

<script>
import {cloneDeep, merge} from 'lodash';
import { v4 } from 'uuid';
import { mapGetters, mapMutations, mapState } from 'vuex';
import TranslateFiled from '../TranslateFiled'
import SwitchCheckbox from '../SwitchCheckbox';

const QuestionType = {
  Open: 'QUESTION_OPEN',
  Closed: 'QUESTION_CLOSED',
  OpenWithFile: 'QUESTION_OPEN_WITH_FILE',
};

const questionTypes = [
  {
    id: QuestionType.Open,
    title: 'open_question',
  },
  {
    id: QuestionType.Closed,
    title: 'closed_question',
  },
  {
    id: QuestionType.OpenWithFile,
    title: 'open_question_with_file',
  },
];

let changeActionTimer = null;
let dragOverThrottleTime = null;

function defaultQuestion() {
  return {
    tempId: v4(),
    edit: true,
    questionType: questionTypes[0],
    question: '',
    answerVariants: [],
  };
}

function defaultAnswerVariant() {
  return {
    tempId: v4(),
    show: true,
    title: '',
    points: 0,
  };
}

export default {
  name: 'EditAdditionalQuestions',
  components: {
    TranslateFiled,
    SwitchCheckbox,
  },
  props: {
    vacancyCreated: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      QuestionType,
      loading: {
        questionsDelete: {},
      },
      draggableQuestionId: null,
      draggableAnswer: null,
    };
  },
  computed: {
    ...mapState('vacancyEdit/sectionAdditionalQuestions', [
      'inputs',
    ]),

    ...mapGetters('vacancyEdit', [
      'afterJustCreated',
      'savedBlocks',
      'originalLocale',
    ]),

    ...mapGetters('user', [
      'isOur',
    ]),

    additionalQuestions: {
      get() {
        return this.inputs.additionalQuestions.value || [];
      },
      set(value) {
        this.setAdditionalQuestionsSectionValue(['additionalQuestions', value]);
      },
    },
    questionTypes() {
      return questionTypes;
    },
    useFieldsTranslations() {
      return this.isOur && this.savedBlocks?.[1] === true && !this.afterJustCreated;
    },
  },
  mounted() {
    this.saveSection();
  },
  methods: {
    ...mapMutations('vacancyEdit/sectionAdditionalQuestions', {
      setAdditionalQuestionsSectionValue: 'setInputValue',
      setStateProperty: 'setProperty',
    }),

    changeAction() {
      this.setAdditionalQuestionsSectionValue(['additionalQuestions', this.additionalQuestions]);

      clearTimeout(changeActionTimer);
      changeActionTimer = setTimeout(this.saveAndSync, 1000);
    },
    async saveAndSync() {
      const result = await this.saveSection();
      if (!result || result.message !== 'SAVED' || !result.data.saved_data?.additionalQuestions) return result;

      this.additionalQuestions = merge(result.data.saved_data.additionalQuestions, this.additionalQuestions);

      return result;
    },
    translateAdditionalQuestionsInput(value) {
      this.setStateProperty(['translateAdditionalQuestions', value]);
    },
    saveSection() {
      return this.$store.dispatch('vacancyEdit/saveSection', {
        sectionName: 'sectionAdditionalQuestions',
      });
    },

    addQuestionBlock() {
      this.additionalQuestions.forEach(q => q.edit = false);
      this.additionalQuestions.push(defaultQuestion());
      this.changeAction();
    },
    async deleteQuestionBlock(item, idx) {
      const loadingId = item.id || item.tempId;
      this.$set(this.loading.questionsDelete, loadingId, true);

      const newAdditionalQuestions = cloneDeep(this.additionalQuestions);
      newAdditionalQuestions.splice(idx, 1);
      this.setStateProperty(['priorityAdditionalQuestions', newAdditionalQuestions]);

      const data = await this.saveAndSync();
        if (data) {
        this.additionalQuestions.splice(idx, 1);
        this.setAdditionalQuestionsSectionValue(['additionalQuestions', this.additionalQuestions]);
        this.setStateProperty(['priorityAdditionalQuestions', null]);
      }

      delete this.loading.questionsDelete[loadingId];
    },
    setQuestionType(item, type) {
      item.questionType = type;

      if (type.id === QuestionType.Closed && !item.answerVariants.length) {
        item.answerVariants.push(defaultAnswerVariant());
      }
      this.changeAction();
    },
    onItemQuestionInput(value, idx) {
      const additionalQuestion = this.additionalQuestions[idx];

      if (additionalQuestion.questionType.id !== QuestionType.Closed) {
        additionalQuestion.answerVariants = [];
      }

      this.changeAction();
    },
    addAnswerVariant(idx) {
      this.additionalQuestions[idx].answerVariants.push(defaultAnswerVariant());
    },
    deleteAnswerVariant(idx, variantIndex) {
      this.additionalQuestions[idx].answerVariants.splice(variantIndex, 1);
      this.changeAction();
    },
    toggleEditMode(idx) {
      const additionalQuestion = this.additionalQuestions[idx];
      if (additionalQuestion.edit) {
        additionalQuestion.answerVariants = additionalQuestion.answerVariants.filter(v => v.title);
      } else {
        this.additionalQuestions.forEach(q => q.edit = false);
      }
      additionalQuestion.edit = !additionalQuestion.edit;

      if (!additionalQuestion.edit) this.onEditEnd();
    },
    onEditEnd() {
      this.changeAction();
    },
    getFormattedText(text) {
      try {
        return Object.entries(JSON.parse(text)).find(([key]) => key === this.$store.state.currentLocale)[1];
      } catch {
        return text;
      }
    },

    setUpperPosition(item, index) {
      if (index === 0) return;
      this.setNewQuestionPosition(item, index - 1);
      this.changeAction();
    },
    setLowerPosition(item, index) {
      if (index === this.additionalQuestions.length - 1) return;
      this.setNewQuestionPosition(item, index + 1);
      this.changeAction();
    },
    setNewQuestionPosition(item, newIndex) {
      this.setNewListPosition(this, 'additionalQuestions', item, newIndex);
    },
    startQuestionDrag(item) {
      this.draggableQuestionId = item.id || item.tempId;
    },
    onQuestionDragOver(item) {
      const throttlingDelay = 500;
      if (Date.now() - throttlingDelay < dragOverThrottleTime) return;
      dragOverThrottleTime = Date.now();

      if (!this.draggableQuestionId || (item.id || item.tempId) === this.draggableQuestionId) return;

      const draggableItem = this.additionalQuestions.find(q => (q.id || q.tempId) === this.draggableQuestionId);
      const newPositionIdx = this.additionalQuestions.findIndex(q => (q.id || q.tempId) === (item.id || item.tempId));
      this.setNewQuestionPosition(draggableItem, newPositionIdx);
    },

    setAnswerUpperPosition({ question, answer, answerIdx }) {
      if (answerIdx === 0) return;
      this.setNewListPosition(question, 'answerVariants', answer, answerIdx - 1);
      this.changeAction();
    },
    setAnswerLowerPosition({ question, answer, answerIdx }) {
      if (answerIdx === question.answerVariants.length - 1) return;
      this.setNewListPosition(question, 'answerVariants', answer, answerIdx + 1);
      this.changeAction();
    },
    onAnswerDragOver({ question, answerIdx }) {
      if (!this.draggableAnswer) return;

      this.setNewListPosition(question, 'answerVariants', this.draggableAnswer, answerIdx);
    },
    onItemDragEnd() {
      this.draggableQuestionId = null;
      this.draggableAnswer = null;
      this.changeAction();
    },

    setNewListPosition(listParentObj, listKey, item, newIndex) {
      const list = cloneDeep(listParentObj[listKey]);
      const currentIndex = list.findIndex(i => (i.id || i.tempId) === (item.id || item.tempId));
      list.splice(currentIndex, 1);
      list.splice(newIndex, 0, item);
      listParentObj[listKey] = list;
    },

    getQuestionInputTitle(questionTypeId) {
      const translateKey = questionTypeId === QuestionType.OpenWithFile ? 'describe_file_upload_request' : 'your_question';
      return this.$tNewVacancy2(translateKey);
    },
  },
};
</script>
